/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Table_Column_Reply_CheckInputs */



/**
* | output |
* | --- |
* | "Reply Check" |
*
* @param {Editor_Table_Column_Reply_CheckInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_table_column_reply_check = /** @type {((inputs?: Editor_Table_Column_Reply_CheckInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Column_Reply_CheckInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Verification reponse")
	if (locale === "de") return /** @type {LocalizedString} */ ("Antwort prüfen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rispondi Verifica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ответить Проверить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Revisión de respuesta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("回复检查")
	if (locale === "ja") return /** @type {LocalizedString} */ ("返信チェック")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उत्तर जांचें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Resposta Verificar")
	return /** @type {LocalizedString} */ ("Reply Check")
});